import { Market } from "../../../../store/markets/reducer";
import { Sport } from "../../../../store/sports/reducer";
import { MatchForecastType } from "../../MatchSwitcher/MatchSwitcher";

import { FormattedOdds } from "../utils";

export type valueof<T> = T[keyof T];

export interface IMatchForecast {
  match_id?: string;
  start_date: string;
  index: number;
  type: MatchForecastType;
  sport: Sport;
  competition_name: string;
  home_player: string;
  away_player: string;
  market: Market;
  formatted_odds: FormattedOdds;
  tip: string;
  reset(): void;
  getMatchDate(): string;
}
const defaultStartDate = (): string => {
  const date = new Date();

  date.setHours(date.getHours());
  date.setMinutes(date.getMinutes());
  return date.toISOString();
};
export class MatchForecast implements IMatchForecast {
  index: number;
  type: MatchForecastType;
  sport: Sport;
  competition_name: string;
  home_player: string;
  away_player: string;
  market: Market;
  formatted_odds: FormattedOdds;
  tip: string;
  match_id?: string;
  start_date: string;

  constructor(
    type: MatchForecastType,
    market: Market,
    sport?: Sport,
    index = 0
  ) {
    this.index = index;
    this.type = type;
    this.competition_name = "";
    this.home_player = "";
    this.away_player = "";
    this.market = market;
    this.formatted_odds = { decimal: "", american: "", fractional: "" };
    this.tip = "";

    this.sport = sport
      ? sport
      : {
          id: "",
          code: "",
          name: "",
          active: false,
        };
    this.start_date = defaultStartDate();
  }

  public reset(): void {
    this.competition_name = "";
    this.home_player = "";
    this.away_player = "";
    this.match_id = undefined;
    this.sport = {
      id: "",
      code: "",
      name: "",
      active: false,
    };
  }

  public getMatchDate(): string {
    return this.start_date;
  }
  public setValue(key: keyof MatchForecast, value: valueof<MatchForecast>) {
    this.setAttribute<MatchForecast, keyof MatchForecast>(this, key, value);
  }

  private setAttribute<T extends Object, U extends keyof T>(
    obj: T,
    key: U,
    value: T[U]
  ) {
    obj[key] = value;
  }
}
